import React, { useState } from 'react';
import ModalTable from '../ModalTable';
import Link from '../Link';

const LinkToModal = ({ linkText, children, modalName = 'modal' }) => {
  const [showModal, setShowModal] = useState(false);
  const toggleShowModal = () => setShowModal(!showModal);
  const linkURL = '' || `?modalName=${modalName}`;

  return (
    <>
      <Link href={linkURL} icon="interrogation" onClick={toggleShowModal}>
        {linkText}
      </Link>
      <ModalTable statusModal={showModal} onClose={toggleShowModal}>
        {children}
      </ModalTable>
    </>
  );
};
export default LinkToModal;
